class Tabs {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        let tabButtons = document.querySelectorAll('[data-tab-button]');
        let tabItems = document.querySelectorAll('[data-tab-item]');

        tabButtons.forEach((button, i) => {
            button.addEventListener('click', evt => {
                self.stripClass(tabButtons);
                self.stripClass(tabItems);
                self.addClass(button);

                tabItems.forEach((item, index) => {
                    if(index === i) {
                        self.addClass(item);
                    }
                });
            });
        });
    }

    addClass(item) {
        item.classList.add('is-active');
    }

    stripClass(items) {
        items.forEach((item) => {
            item.classList.remove('is-active');
        });
    }
}

export default Tabs;
